import isString from 'lodash/isString';

import './lib/iscroll';
import './notice/notice';

import * as Util from './common/util';
import Header from './header/HeaderMain';
import Left from './left/LeftMain';
import Right from './right/RightMain';
import Character from './character/Character';
import PurpleBottomNav from "./purple/PurpleBottomNav";
import PurplePanel from "./purple/PurplePanel";
import PurpleUrl from './purple/PurpleUrl';
import Dimmed from './components/Dimmed';
import Common from './common/Common';
import notiFriends from './notice/notiFriends';
import modal from './components/Modal';
import { CNB_TYPE, PLAYNC_DOMAIN, PLATFORM } from './common/const';

/*
 * 경고!
 * babel core-js 3으로 트랜스파일.
 * ie에서 stackoverflow 간혹 발생. (반드시 ie에서 확인 후 배포)
 * playnclib 충돌을 피해 jQuery alias 사용
 * */
class App {
    constructor() {
        this.con = jQuery('#nc-cnb');
        this.orgClass = this.con.attr('class');
        this.com = Common.instance;
        this.dim = Dimmed.instance;
        this.com.init();

        this.deviceName = this.com?.device;
        this.browser = (Util.nowBrowser || '').toLowerCase();
        this.theme = null;
    }
    
    start(_config) {
        this.startconfig = this.setOriginConfigData(_config);
        
        this.destroy();
        if (typeof window.userData !== 'object') window.userData = { isLogin: false, locale: 'ko-KR' };
        
        this.errCnt = 0;
        this.com.setStaticHostByArea(this.startconfig?.area);
        this.loadStartCnbData(document.documentElement.lang || 'ko');
    }

    loadStartCnbData(_loc) {
        const localeName = this.setLocaleName(_loc);

        jQuery.ajax({
            dataType: 'json', type: "GET",
            url: this.com.staticHost + '/i18n/cnb/' + localeName + '.json',
        })
        .done((_d) => {
            this.com.l10nData = _d;
            this.loadCompleteCnbData();
        })
        .fail((_d) => {
            this.errCnt++;
            console.log('err :', this.errCnt, _d);
            if(this.errCnt>10) return false;
            this.loadStartCnbData('en');
        });
    }

    setLocaleName(loc) {
        switch(loc) {
            case 'zh':
                return 'zh_Hant';
            case 'es':
                const userLocale = window?.userData?.locale;
                const dataCountry = document.querySelector('html')?.dataset?.country;
                const isEs = userLocale ? (/-es$/i).test(userLocale) : dataCountry ? (/^es$/i).test(dataCountry) : false;
                return isEs ? 'es_ES' : 'es_MX';
            default:
                return loc;
        }
    }

    loadCompleteCnbData() {
        this.setting(this.startconfig);

        // nshop coupon
        const useNshopInstance = window.nshop && window.nshop.popup; // 이미 사용중
        const useNshopPopup = this.com.config.useNshopPopup; // PURPLE 타입이면 popup.min.js 호출하지 않음

        if (!useNshopInstance && useNshopPopup) {
            jQuery.ajax({
                dataType: 'script',
                url: this.com.staticHost + '/nshop/common/popup/dist/js/popup-0.0.4-min.js',
                success: () => {},
            });
        }
    }

    destroy() {
        this.leftP && this.leftP.destroy();
        this.rightP && this.rightP.destroy();
        this.purpleP && this.purpleP.destroy();
    }

    setting(_config) {
        this.com.config = _config;

        this.con.attr('data-ncc-device', this.deviceName);

        if (this.com.env !== 'live') {
            this.con.attr('data-ncc-browser', this.browser);
        }

        this.con.attr('class', this.orgClass);
        this.con.addClass(this.com.theme.classes.theme);

        let isUserMenu = !(typeof this.com.config.useLoginMenu === 'undefined' ?
            true :
            this.com.config.useLoginMenu);
        if (isUserMenu) this.con.attr('data-disable-menu', '');

        if (this.com.config.type) this.con.attr('data-cnb-type', this.com.config.type.toLowerCase());
        if (this.com.config.theme && this.com.config.theme.colorScheme) {
            let scheme = this.com.config.theme.colorScheme;
            if (!isString(scheme)) {
                scheme = scheme.name;
            }
            this.con.attr('data-theme', scheme);
            this.theme = scheme;
        }
        
        this.setHtmlPlatform(); // 퍼플 플랫폼 명시를 위해 html[data-platform=""] 추가
        this.setHtmlService(); // NCUI 컬러테마 적용을 위해 html[data-service=""] 추가

        // iphoneX && chrome 체크!
        if (Util.isiPhoneX && navigator.userAgent.match('CriOS')) {
            this.con.addClass('iphonex-chrome');
        }

        this.setComponentByType(); // CNB 컴포넌트 구성
    }

    // CNB 타입 정의 (퍼플 런처 타입 CNB 내부에서 설정)
    setOriginConfigData(config = {}) {
        const { purpleCheck } = this.com || {};
        const { isPurpleLauncher } = purpleCheck;

        return {
            ...config,
            type: isPurpleLauncher ? 'PURPLE' : config?.type
        };
    }

    // 퍼플 플랫폼 명시를 위해 html[data-platform=""] 추가
    setHtmlPlatform() {
        let { platform } = this.com || {};

        if(!platform) {
            return;
        }

        if(platform === PLATFORM.PURPLE.INAPP || platform === PLATFORM.PURPLE.WEBVIEW) {
            platform = PLATFORM.PURPLE.APP;
            //document.querySelector('html')?.setAttribute('data-apptype', this.com.platform);
        }

        document.querySelector('html')?.setAttribute('data-platform', platform);
    }

    // NCUI 컬러테마 적용을 위해 html[data-service=""] 추가
    setHtmlService() {
        const $html = document.querySelector('html');
        let service = $html?.dataset?.service || null;

        if(!!service) return; // html[data-service]값이 있으면 패스

        if(!!this.theme) {
            service = this.theme;
            $html.dataset.service = service;
        }
    }

    resetSearchBar() {
        if (this.header) {
            this.header._search.hideSearchField();
        }
    }

    // CNB 타입에 따른 컴포넌트 구성
    setComponentByType() {
        const { purpleCheck, config } = this.com || {};
        const { isPurpleLauncher } = purpleCheck;
        const isPurpleType = config?.type === CNB_TYPE.PURPLE;
        isPurpleType && isPurpleLauncher ? this.setPurpleType(config) : this.setDefaultType(config);
    }

    setDefaultType(config) {
        const { useNotice, useCharChangeMenu } = config || {};
        const header = new Header(config);
        const leftP = new Left(config);
        const rightP = new Right(config);
        const characterP = new Character(config, useCharChangeMenu);

        this.con.html(header.markUp + leftP.markUp + rightP.markUp + characterP.markUp);
        this.dim.init();

        header.start();
        leftP.start();
        rightP.start();
        characterP.start();
        useNotice && notiFriends.init();

        this.leftP = leftP;
        this.rightP = rightP;
        this.header = header;
    }

    setPurpleType(config) {
        const { purpleCheck } = this.com || {};
        const { isPurpleLauncher, isPurpleInApp, isPurpleApp } = purpleCheck;
        const { useCharChangeMenu } = config;
        const uiMap = {
            characterP: new Character(config, useCharChangeMenu)
        };

        if(isPurpleLauncher) {
            uiMap.bottomNav = new PurpleBottomNav(config);
        } 

        /* 인앱브라우저에서는 퍼플 우측 드로어 노출하지 X. 추후에 웹뷰 사용 시 다시 열기.
        if(isPurpleApp) {
            uiMap.purpleP = new PurplePanel(config);
        }*/

        const uiMapValues = Object.values(uiMap) || [];

        this.con.html(uiMapValues?.map(v => v?.markUp || '')?.join(''));
        this.dim.init();
        uiMapValues?.forEach(v => v?.start());

        // 인앱브라우저에서는 퍼플 우측 드로어 노출하지 X. 추후에 웹뷰 사용 시 다시 열기.
        //this.purpleP = uiMap?.purpleP;
    }

    openCharacterPan() {
        this.dim.openClose(true, 'right');
        if (typeof window.ncNotice === 'object') window.ncNotice.start();
        jQuery('.ncc-character-panel').addClass('is-active');
        jQuery('#nc-cnb .ncc-profile-links a.ncc-profile-charchange').trigger('click');
    }

    message(msg) {
        modal.openAlert({ title: msg });
    }

    // 다운로드 플랫폼 레이어 노출/숨김
    platformLayerActive(isActive = false) {
        const { useGameStart, platformDownload } = this.com.config;
        if(useGameStart !== 'platformDownload' || !Array.isArray(platformDownload)) {
            return;
        }
        this.header.platformLayerActive(isActive);
    }

    // 퍼플 - panel 노출
    /*showPurplePanel(isActive) {
        const { purpleCheck } = this.com || {};
        
        if(!purpleCheck.isPurpleApp) {
            return;
        }

        isActive ? this.purpleP?.show() : this.purpleP?.hide();
    }*/

    // 퍼플 - 퍼플 에러페이지로 이동
    goPurpleErrorPage() {
        const env = this.com?.env in PLAYNC_DOMAIN ? this.com?.env : 'live';
        PurpleUrl.goErrorPage(env);
    }

    // 퍼플 플랫폼 
    getPurplePlatform() {
        return this.com?.getPurplePlatform();
    }
}

window.cnb = new App();